import i18n from '../i18n';
import { normalizeLanguage } from '../i18n/languages';

/**
 * Kod içinde kalan kısa arayüz metinleri için: Türkçe dışındaki tüm dillerde İngilizce metin.
 * Yeni dillerde düzgün çeviri için bu metinleri zamanla JSON anahtarlarına taşı.
 * (Hikâye ekranı gibi içeriği zaten Türkçe olan yerlerde JSON anahtarı açmadan çeviri.)
 */
export const tl = (tr, en) => (normalizeLanguage(i18n.language) === 'tr' ? tr : en);
